import { Navigate, Route, Routes, useParams } from "react-router-dom"
import type { AppShell } from "@/App"
import { ReceiptsList } from "./ReceiptsList"
import { NewReceipt } from "./NewReceipt"
import { ReceiptDetailPage } from "./ReceiptDetail"
import { RondasList } from "./RondasList"
import { RondaDetailPage } from "./RondaDetail"
import { ArmazemSettings } from "./Settings"

/**
 * Área Armazém — receção de material com séries (Fase 2, ADR-008) e a Ronda
 * de stock (0.32.0: substitui a Contagem de séries e a Conferência). Montada
 * em `/armazem/*` pelo App. Pensada primeiro para o telemóvel do armazém; o
 * computador do escritório vem a seguir.
 *
 * `armazem-area` sobe o texto pequeno para 14 px no telemóvel (index.css).
 */
export function ArmazemArea({ shell }: { shell: AppShell | null }) {
  if (!shell) return null
  return (
    <div className="armazem-area">
      <Routes>
        <Route index element={<ReceiptsList shell={shell} />} />
        <Route path="nova" element={<NewReceipt shell={shell} />} />
        <Route path="ronda" element={<RondasList shell={shell} />} />
        <Route path="ronda/:id" element={<RondaDetailPage shell={shell} />} />
        {/* Ligações antigas (Contagem, Conferência) → Ronda. */}
        <Route path="contagem/*" element={<Navigate to="/armazem/ronda" replace />} />
        <Route path="conferencia" element={<Navigate to="/armazem/ronda" replace />} />
        <Route path="conferencia/:id" element={<LegacyCheck />} />
        <Route path="configuracoes" element={<ArmazemSettings shell={shell} />} />
        <Route path=":id" element={<ReceiptDetailPage shell={shell} />} />
      </Routes>
    </div>
  )
}

/** `/armazem/conferencia/<id>` → a mesma linha, agora uma ronda. */
function LegacyCheck() {
  const { id = "" } = useParams()
  return <Navigate to={`/armazem/ronda/${id}`} replace />
}
